module.exports = __webpack_public_path__ + "img/logo-enigio-white-rgb.06f2b561.svg";